<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
      <div class="ts-app-shell--header">
        <h5 class="dashboard-title">Skills Passport Summary</h5>

        <div class="ts-app-shell--header_actions flexed">
          <button class="ts-btn ts-btn-small" @click="goBack">Back</button>
        </div>
      </div>
      <p>
        On this page are the list of career plan you selected for your growth.
        You can manage them here and prioritize each item you want to achieve or
        remove them completely.
      </p>

      <el-divider></el-divider>

      <div class="skillspassport-body">
        <div v-if="showNoData" class="no-data">
          <div class="no-data-text">You have no Skills Passport to Manage.</div>
        </div>

        <div v-else class="skillspassport-accordion">
          <el-collapse accordion v-model="activeName">
            <el-collapse-item
              v-for="(passport, index) in skillsPassports"
              :key="index"
              :name="index"
            >
              <template slot="title">
                <span
                  class="accordion-title"
                  style="font-weight: bold; font-size: 14px"
                >
                  {{ passport.taskDescription.title }}
                </span>
              </template>

              <SkillsPassportCard
                :PassportDetails="passport"
                :Search="false"
                :ChartOptions="passport.ChartOptions"
                @delete-skills-passport="deleteSkillsPassport"
              >
              </SkillsPassportCard>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>

    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import SkillsPassportCard from "../../../components/SkillsPassportCard";
import TSLoading from "../../../components/TSLoading.vue";

export default {
  components: {
    SkillsPassportCard,
    TSLoading
  },
  created() {
    this.loading = true;

    var selectedCurrency = this.$i18n.messages[localStorage.getItem("locale")];
    var exrate = this.$ExchangeRates.data.filter(r => r.base == "USD")[0]
      ?.rates[selectedCurrency.currency];
    var symbol = selectedCurrency.currency === "USD" ? "$" : "£";

    this.$store
      .dispatch("skillspassport/getSkillsPassportSummary")
      .then(res => {
        this.skillsPassports = res;
        if (!res || res.length == 0) this.showNoData = true;
        else {
          res.forEach(passport => {
            this.passportLabels = [];
            this.chartOptions = {};
            var less =
              "10% of workers earn " +
              symbol +
              (
                passport.jobOutlook.salary.annual_10th_percentile * exrate
              ).toLocaleString("en-US") +
              " or less";
            var ave =
              "Workers on average earn " +
              symbol +
              (
                passport.jobOutlook.salary.annual_median * exrate
              ).toLocaleString("en-US");
            var more =
              "10% of workers earn " +
              symbol +
              (
                passport.jobOutlook.salary.annual_90th_percentile * exrate
              ).toLocaleString("en-US") +
              " or more";
            this.passportLabels.push(less);
            this.passportLabels.push(ave);
            this.passportLabels.push(more);

            this.chartOptions.labels = this.passportLabels;
            passport.ChartOptions = this.chartOptions;
          });
        }

        this.loading = false;

        var legendPosition = window.innerWidth > 759 ? "right" : "bottom";
        this.chartOptions.legend.position = legendPosition;
      });
  },
  computed: {
    applicantUserInfo() {
      return this.$store.state.account.applicant_user_info;
    }
  },
  data() {
    return {
      loading: false,
      showNoData: false,
      onetCode: null,
      activeName: null,
      skillsPassports: [],
      api: "",
      passportLabels: [],
      chartOptions: {
        legend: {
          position: "bottom",
          horizontalAlign: "left"
        },
        labels: [],
        chart: {
          type: "donut",
          height: "auto",
          width: "auto"
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          pie: {
            donut: {
              size: "45%"
            }
          }
        }
      }
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    deleteSkillsPassport(passportDetails) {
      this.$confirm(
        `<p style="text-align:center;padding-bottom:20px;">Are you sure you want to delete your skills passport?</p>`,
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      ).then(() => {
        this.loading = true;
        this.$store
          .dispatch(
            "skillspassport/deleteSkillsPassport",
            passportDetails.taskDescription.code
          )
          .then(res => {
            this.$message.success(`Skills passport deleted!`);
            this.$store
              .dispatch("skillspassport/getSkillsPassportSummary")
              .then(res => {
                this.skillsPassports = res;
                if (res.length == 0) this.showNoData = true;
                this.activeName = null;
                this.loading = false;
              });
          });
      });
    }
  }
};
</script>

<style scoped>
.accordion-title {
  line-height: 15px !important;
}
</style>
